import Tag from 'src/components/primitives/Tag/Tag';
import VariantTag from 'src/components/Tags/VariantTag';

interface Props {
	newTag?: boolean;
	hotTag?: boolean;
	tagLabel?: string;
}

export default function NavItemTags({ newTag, hotTag, tagLabel }: Props) {
	if (!newTag && !hotTag && !tagLabel) {
		return null;
	}

	return (
		<>
			{newTag && <VariantTag variant="new" />}
			{hotTag && <Tag className="bg-star-yellow text-black">Hot</Tag>}
			{tagLabel && (
				<Tag className="bg-button-secondary-bg-hover text-text-default">
					{tagLabel}
				</Tag>
			)}
		</>
	);
}
